var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42642 6.96791C5.85838 2.65597 7.07437 0.5 8.99999 0.5C10.9256 0.5 12.1416 2.65597 14.5736 6.96791L14.8766 7.50522C16.8976 11.0884 17.908 12.88 16.9948 14.19C16.0815 15.5 13.822 15.5 9.30304 15.5H8.69694C4.17796 15.5 1.91847 15.5 1.0052 14.19C0.0919416 12.88 1.10242 11.0884 3.12337 7.50523L3.42642 6.96791ZM8.99999 4.04167C9.34517 4.04167 9.62499 4.32149 9.62499 4.66667V8.83333C9.62499 9.17851 9.34517 9.45833 8.99999 9.45833C8.65481 9.45833 8.37499 9.17851 8.37499 8.83333V4.66667C8.37499 4.32149 8.65481 4.04167 8.99999 4.04167ZM8.99999 12.1667C9.46023 12.1667 9.83332 11.7936 9.83332 11.3333C9.83332 10.8731 9.46023 10.5 8.99999 10.5C8.53975 10.5 8.16666 10.8731 8.16666 11.3333C8.16666 11.7936 8.53975 12.1667 8.99999 12.1667Z",
    fill: "#F74B4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedWarning);
export default __webpack_public_path__ + "static/media/redWarning.1c604aa4ddfd5545e717d6bc18a5adcb.svg";
export { ForwardRef as ReactComponent };